// src/config/excelUpload/studentBasicInfoConfig.js
export const studentBasicInfoConfig = {
  // 기본 설정 (개발자 참고용)
  title: "학생계정_기본정보",
  description: "username이 존재하면 수정, 없으면 신규 생성됩니다.",

  // 실제 사용 설정
  maxRows: 500,
  maxFileSize: 10 * 1024 * 1024, // 10MB
  primaryKey: "username", // 기존 데이터 비교 기준이 되는 키

  // 컬럼 정의
  columns: [
    {
      field: "username",
      headerName: "아이디 *",
      table: "users",
      required: true,
      unique: true,
      maxLength: 50,
      validation: {
        pattern: /^[^@]*@[^@]+$/,
        message: "아이디는 '@학교아이디' 형식으로 입력해주세요",
      },
    },
    {
      field: "password",
      headerName: "비밀번호 *",
      table: "users",
      required: true,
      minLength: 4,
      maxLength: 100,
      onUpdate: "skip", // update 시에는 validation 건너뛰기 (기존 값 유지)
    },
    {
      field: "fullname",
      headerName: "이름 *",
      table: "users",
      required: true,
      maxLength: 50,
    },
    {
      field: "gender",
      headerName: "성별 *",
      table: "users",
      required: true,
      validation: {
        options: ["남", "여"],
        message: "성별은 '남' 또는 '여'로 입력해주세요",
      },
    },
    {
      field: "other_name",
      headerName: "다른 이름",
      table: "users",
      required: false,
      maxLength: 100,
    },
    {
      field: "birthday",
      headerName: "생년월일",
      table: "users",
      type: "date",
      required: false,
      validation: {
        pattern: /^\d{4}-\d{2}-\d{2}$/,
        message:
          "생년월일은 YYYY-MM-DD 형식 또는 엑셀 날짜 형식으로 입력해주세요",
      },
    },
    {
      field: "idatschool",
      headerName: "학번",
      table: "users",
      required: false,
      maxLength: 50,
    },
    {
      field: "email",
      headerName: "이메일",
      table: "users",
      required: false,
      maxLength: 50,
      validation: {
        pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "올바른 이메일 형식으로 입력해주세요 (예: user@example.com)",
      },
    },
    // StudentInfo 테이블 필드들
    {
      field: "korean_id_no",
      headerName: "주민등록번호",
      table: "studentinfos",
      required: false,
      maxLength: 50,
    },
    {
      field: "zipcode",
      headerName: "우편번호",
      table: "studentinfos",
      required: false,
      maxLength: 50,
    },
    {
      field: "address",
      headerName: "주소",
      table: "studentinfos",
      required: false,
      maxLength: 150,
    },
    {
      field: "address_detail",
      headerName: "상세주소",
      table: "studentinfos",
      required: false,
      maxLength: 150,
    },
    {
      field: "phone_number",
      headerName: "전화번호",
      table: "studentinfos",
      required: false,
      maxLength: 50,
    },
    {
      field: "entrance_date",
      headerName: "입학일",
      table: "studentinfos",
      type: "date",
      required: false,
      validation: {
        pattern: /^\d{4}-\d{2}-\d{2}$/,
        message: "날짜는 YYYY-MM-DD 형식 또는 엑셀 날짜 형식으로 입력해주세요",
      },
    },
    {
      field: "enrollment_status",
      headerName: "재학상태",
      table: "studentinfos",
      required: false,
      maxLength: 50,
      defaultValue: "재학중",
    },
    {
      field: "termination_date",
      headerName: "재학종료일",
      table: "studentinfos",
      type: "date",
      required: false,
      validation: {
        pattern: /^\d{4}-\d{2}-\d{2}$/,
        message: "날짜는 YYYY-MM-DD 형식 또는 엑셀 날짜 형식으로 입력해주세요",
      },
    },
    {
      field: "father_name",
      headerName: "부이름",
      table: "studentinfos",
      required: false,
      maxLength: 50,
    },
    {
      field: "father_phone",
      headerName: "부연락처",
      table: "studentinfos",
      required: false,
      maxLength: 50,
    },
    {
      field: "mother_name",
      headerName: "모이름",
      table: "studentinfos",
      required: false,
      maxLength: 50,
    },
    {
      field: "mother_phone",
      headerName: "모연락처",
      table: "studentinfos",
      required: false,
      maxLength: 50,
    },
    {
      field: "memo",
      headerName: "메모",
      table: "studentinfos",
      required: false,
      maxLength: 500,
    },
  ],

  // 템플릿 샘플 데이터
  templateSamples: [
    {
      username: "student001@schoolid",
      password: "1234",
      fullname: "홍길동",
      other_name: "Hong Gildong",
      gender: "남",
      birthday: "2010-03-15",
      idatschool: "20240001",
      email: "student001@example.com",
      korean_id_no: "101234-3******",
      zipcode: "12345",
      address: "서울시 강남구 테헤란로 123",
      address_detail: "101동 1001호",
      phone_number: "02-1234-5678",
      entrance_date: "2024-03-01",
      termination_date: "2025-03-01",
      enrollment_status: "재학중",
      father_name: "홍아버지",
      father_phone: "010-1234-5678",
      mother_name: "홍어머니",
      mother_phone: "010-1234-5679",
      memo: "모범학생입니다.",
    },
  ],
};

// 교사 정보 일괄 업로드 설정
export const teacherInfoConfig = {
  // 기본 설정 (개발자 참고용)
  title: "교사계정_교사정보",
  description: "username이 존재하면 수정, 없으면 신규 생성됩니다.",

  // 실제 사용 설정
  maxRows: 500,
  maxFileSize: 10 * 1024 * 1024, // 10MB
  primaryKey: "username", // 기존 데이터 비교 기준이 되는 키

  // 컬럼 정의
  columns: [
    // Users 테이블 필드들 (동일)
    {
      field: "username",
      headerName: "아이디 *",
      table: "users",
      required: true,
      unique: true,
      maxLength: 50,
      validation: {
        pattern: /^[^@]*@[^@]+$/,
        message: "아이디는 '@학교아이디' 형식으로 입력해주세요",
      },
    },
    {
      field: "password",
      headerName: "비밀번호 *",
      table: "users",
      required: true,
      minLength: 4,
      maxLength: 100,
      onUpdate: "skip", // update 시에는 validation 건너뛰기 (기존 값 유지)
    },
    {
      field: "fullname",
      headerName: "이름 *",
      table: "users",
      required: true,
      maxLength: 50,
    },
    {
      field: "gender",
      headerName: "성별 *",
      table: "users",
      required: true,
      validation: {
        options: ["남", "여"],
        message: "성별은 '남' 또는 '여'로 입력해주세요",
      },
    },
    {
      field: "other_name",
      headerName: "다른 이름",
      table: "users",
      required: false,
      maxLength: 100,
    },
    {
      field: "birthday",
      headerName: "생년월일",
      table: "users",
      type: "date",
      required: false,
      validation: {
        pattern: /^\d{4}-\d{2}-\d{2}$/,
        message:
          "생년월일은 YYYY-MM-DD 형식 또는 엑셀 날짜 형식으로 입력해주세요",
      },
    },
    {
      field: "email",
      headerName: "이메일",
      table: "users",
      required: false,
      maxLength: 50,
      validation: {
        pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "올바른 이메일 형식으로 입력해주세요 (예: user@example.com)",
      },
    },
    // TeacherInfos 테이블 필드들
    {
      field: "korean_id_no",
      headerName: "주민등록번호",
      table: "teacherinfos",
      required: false,
      maxLength: 50,
    },
    {
      field: "entrance_date",
      headerName: "입사일",
      table: "teacherinfos",
      type: "date",
      required: false,
      validation: {
        pattern: /^\d{4}-\d{2}-\d{2}$/,
        message: "날짜는 YYYY-MM-DD 형식 또는 엑셀 날짜 형식으로 입력해주세요",
      },
    },
    {
      field: "zipcode",
      headerName: "우편번호",
      table: "teacherinfos",
      required: false,
      maxLength: 50,
    },
    {
      field: "address",
      headerName: "주소",
      table: "teacherinfos",
      required: false,
      maxLength: 150,
    },
    {
      field: "address_detail",
      headerName: "상세주소",
      table: "teacherinfos",
      required: false,
      maxLength: 150,
    },
    {
      field: "phone_number",
      headerName: "전화번호",
      table: "teacherinfos",
      required: false,
      maxLength: 50,
    },
    {
      field: "position",
      headerName: "직위(직급)",
      table: "teacherinfos",
      required: false,
      maxLength: 50,
    },
    {
      field: "termination_date",
      headerName: "퇴사일",
      table: "teacherinfos",
      type: "date",
      required: false,
      validation: {
        pattern: /^\d{4}-\d{2}-\d{2}$/,
        message: "날짜는 YYYY-MM-DD 형식 또는 엑셀 날짜 형식으로 입력해주세요",
      },
    },
    {
      field: "memo",
      headerName: "메모",
      table: "teacherinfos",
      required: false,
      maxLength: 500,
    },
  ],

  // 템플릿 샘플 데이터
  templateSamples: [
    {
      username: "teacher001@schoolid",
      password: "1234",
      fullname: "김선생",
      other_name: "Kim Teacher",
      gender: "여",
      birthday: "1985-05-20",
      email: "teacher001@example.com",
      korean_id_no: "850520-2******",
      entrance_date: "2024-03-01",
      zipcode: "13529",
      address: "경기 성남시 분당구 판교역로 166",
      address_detail: "카카오 판교 아지트",
      phone_number: "010-1234-5678",
      position: "부장",
      termination_date: "2025-03-01",
      memo: "우수교사입니다.",
    },
  ],
};
